function setItem$1(key, value) {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(key, value);
}
function getItem$1(key) {
  if (typeof window === 'undefined') return;
  return window.sessionStorage.getItem(key);
}
function removeItem$1(key) {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(key);
}
function getRedirectUrl() {
  return getItem$1('WS_REDIRECT_URL');
}
function setRedirectUrl(url) {
  setItem$1('WS_REDIRECT_URL', url);
}
function removeRedirectUrl() {
  removeItem$1('WS_REDIRECT_URL');
}
const wsSessionStorage = {
  getItem: getItem$1,
  setItem: setItem$1,
  removeItem: removeItem$1,
  getRedirectUrl,
  setRedirectUrl,
  removeRedirectUrl
};

function setItem(key, value) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(key, value);
}
function getItem(key) {
  if (typeof window === 'undefined') return;
  return window.localStorage.getItem(key);
}
function removeItem(key) {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(key);
}
function getWsToken() {
  return getItem('WS_TOKEN');
}
function setWsToken(token, isSSO) {
  if (token) {
    setItem('WS_TOKEN', token);
  } else {
    removeItem('WS_TOKEN');
  }
  if (isSSO === true) {
    setItem('WS_IS_SSO', 'Y');
  } else {
    removeItem('WS_IS_SSO');
  }
}
function resetWsToken() {
  setWsToken(undefined, false);
}
function removeWsToken() {
  removeItem('WS_TOKEN');
}
function setWsIsSso() {
  setItem('WS_IS_SSO', 'Y');
}
function getWsIsSso() {
  // TODO: - (FUTURE) Store email as well? WS_LOGIN_HINT - would need 'remember me' checkbox
  return getItem('WS_IS_SSO');
}
function getWsCompanyId() {
  return getItem('WS_SELECTED_COMPANY');
}
function setWsCompanyId(selectedCompany) {
  setItem('WS_SELECTED_COMPANY', selectedCompany);
}
function getCoreCompanyId() {
  return getItem('CORE_COMPANY_ID');
}
function setCoreCompanyId(selectedCompany) {
  setItem('CORE_COMPANY_ID', selectedCompany);
}
const wsLocalStorage = {
  getItem,
  setItem,
  removeItem,
  getWsToken,
  setWsToken,
  resetWsToken,
  removeWsToken,
  getWsIsSso,
  setWsIsSso,
  getWsCompanyId,
  setWsCompanyId,
  getCoreCompanyId,
  setCoreCompanyId
};

export { wsLocalStorage, wsSessionStorage };
